export default __webpack_public_path__ + "static/media/ipfs.2c899a97.png";